import useSWR from "swr";
import { type ReaderReport } from "../types";
import { simpleFetcher } from "../fetcher";

export const useReaderReport = (documentVersionId: number | undefined) => {
  return useSWR<ReaderReport, Error>(
    documentVersionId
      ? `/api/v2/document-versions/${documentVersionId}/readers`
      : null,
    simpleFetcher,
  );
};
